import React from "react";

// Here, we display our Navbar
const Title = () => {
  return <div className="title">NRCC Coding Club</div>;
};

export default Title;
